import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import withLocalized from 'modules/localization/withLocalized'
import { loadPro } from 'modules/pros/actions';

const getOrganizers = (state) => state.entities.pros

const getPro = id => createSelector(
  [ getOrganizers ], (pros) => {
    if(!isNaN(parseInt(id, 10))){
      return (pros && id in pros) ? pros[parseInt(id, 10)] : {}
    }

    // not a numeric id, try to find pro by machine_name
    let res = {}
    for (const key in pros) {
      if (pros.hasOwnProperty(key) && (pros[key].machine_name === id)) {
        res = pros[key]
        break
      }
    }
    return res
  }
)

const withPro = (WrappedComponent) => {
  class WithPro extends Component {
    componentWillMount() {
      this.loadData()
    }

    loadData() {
      const { id, loadPro } = this.props
      if(id){
        loadPro(id)
      }
    }

    render() {
      const {
        machine_name,
        hide_from_listings = false,
      } = this.props
      if(!machine_name || hide_from_listings){
        return null
      }
      return <WrappedComponent {...this.props} />;
    }
  }
  WithPro.displayName = `WithPro(${WrappedComponent.displayName || WrappedComponent.name})`;
  return WithPro
}

const mapStateToProps = (state, ownProps) => {
  const {
    id,
  } = ownProps
  const pro = getPro(id)(state)
  return {
    ...ownProps,
    ...pro,
  }
};


export default WrappedComponent => compose(
  withLocalized,
  connect(
    mapStateToProps, {
      loadPro
    }
  ),
  withPro,
)(WrappedComponent)



// WEBPACK FOOTER //
// ./src/utils/withPro.js